module.exports = __webpack_public_path__ + "img/food_15.7f724ad0.jpg";